import theme from 'styled-theming'

export const batikalColor = '#4277b9'
export const batikalSecondayColor = '#35d89c' // green
export const batikalWarningColor = '#fee34a'
export const batikalRedColor = '#ff5b5b'
//light color
export const backgroundColorLight = '#fff'
export const textColorLight = '#111'

//dark color
export const backgroundColorDark = '#1a1a1a'
export const textColorDark = '#fff'

export const separatorDark = '#474747'
export const separatorLight = '#AAA'

export const placeholderDark = '#AAA'
export const placeholderLight = '#AAA'

export const navigationBlue = '#0984FF'

export const gradientColorResult: Array<string> = ['#60A4E9', '#4277B9']

export const sectionColorsBeton: { [x: string]: string } = {
  S100BETON: '#7E848A'
}

export const sectionColors: { [x: string]: string } = {
  S00GAZ: '#FFE400',
  S01ECS: '#F4603C',
  S02BILANFINECO: '#008EDD',
  S03AIR: '#00A790',
  S04CHAUDIERE: '#0FB240',
  S06DECHYDRO: '#61CAE4',
  S07RADIATEUR: '#F14855',
  S08VASEEXPANSION: '#FF0F00',
  S09CIRCULATEUR: '#B63591',
  S10TUYAUTERIE: '#1C67BD',
  S11PERTECHARGE: '#FFD705',
  S12VOLINSTCHAUF: '#61CCE3',
  S13CHAUFFERIE: '#11D088',
  S14VANNE: '#8259AD',
  S15BOIS: '#5AD54D', //#f7941e',
  S16TRAITEMENTDEAU: '#62CAE4',
  S17COGENERATION: '#00A790',
  S18VENTILATION: '#00CFB5',
  S21RENDEMENT: '#4376B9',
  POOCOMMON: '#F4603C',
  P01CREALOGCOL: '#fe4e3c'
}

export const backgroundColor = theme('mode', {
  light: backgroundColorLight,
  dark: backgroundColorDark
})

export const primaryColor = theme('mode', {
  light: batikalColor,
  dark: batikalColor
})

export const secondaryColor = theme('mode', {
  light: batikalSecondayColor,
  dark: batikalSecondayColor
})

export const textColor = theme('mode', {
  light: textColorLight,
  dark: textColorDark
})

export const textColorReverse = theme('mode', {
  light: textColorDark,
  dark: textColorLight
})

export const textDescr = theme('mode', {
  light: textColorLight,
  dark: textColorDark
})

export const warningColor = theme('mode', {
  light: batikalWarningColor,
  dark: batikalWarningColor
})

export const separatorColor = theme('mode', {
  light: separatorLight,
  dark: separatorDark
})

export const placeholderColor = theme('mode', {
  light: placeholderLight,
  dark: placeholderDark
})

export const separatorLineColor = theme('mode', {
  light: '#ECEFF1',
  dark: '#2a2a2a'
})

export const dangerColor = 'rgba(200, 0, 0, 0.8)'
